import React from 'react';
import "./MatchCard.css";

const MatchCard = ({ matchData }) => {
  const renderCricketScore = (scores, playerIndex) => {
    if (!scores) return '-';
    const index = playerIndex + 1;
    const runs = scores[`runs${index}`];
    const wickets = scores[`wickets${index}`];
    const overs = scores[`overs${index}`];
    
    return runs ? `${runs}/${wickets} (${overs})` : '-';
  };

  const renderSetScore = (scores, playerIndex, isMobile = false) => {
    if (!scores) return '-';
    const maxSets = 5;
    const sets = [];
    
    for (let i = 1; i <= maxSets; i++) {
      const score = scores[`set${i}Team${playerIndex + 1}`];
      if (score !== undefined) {
        sets.push(score);
      }
    }

    return (
      <div className={`playerScores ${isMobile ? 'setScoresMobile' : 'setScoresDesktop'}`}>
        {sets.map((score, idx) => (
          <span key={idx} className="setScore">
            {score}
          </span>
        ))}
      </div>
    );
  };

  const renderSimpleScore = (scores, playerIndex) => {
    if (!scores) return '-';
    return scores[`team${playerIndex + 1}`] || '-';
  };

  const renderScore = (scores, playerIndex, sport, isMobile = false) => {
    switch (sport) {
      case 'Cricket':
        return (
          <div className="text-right">
            {renderCricketScore(scores, playerIndex)}
          </div>
        );
      case 'Tennis':
      case 'Volleyball':
      case 'Badminton':
      case 'Table Tennis':
        return renderSetScore(scores, playerIndex, isMobile);
      case 'Football':
      case 'Basketball':
      case 'Hockey':
      case 'Rugby':
        return (
          <div className="text-right">
            {renderSimpleScore(scores, playerIndex)}
          </div>
        );
      default:
        return (
          <div className="text-right">-</div>
        );
    }
  };

  const renderPlayers = () => {
    if (matchData.isTeamMatch) {
      return matchData.teams.map((teamData, index) => ({
        name: teamData.team.name,
        avatar: teamData.team.avatar || "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
        scores: matchData.scores || [],
        isWinner: matchData.winner?.type === 'Team' && matchData.winner?.ref?._id === teamData.team._id
      }));
    } else {
      return matchData.players.map(player => ({
        name: player.userName,
        avatar: player.avatar || "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
        scores: matchData.scores || [],
        isWinner: matchData.winner?.type === 'User' && matchData.winner?.ref?._id === player._id
      }));
    }
  };

  const players = renderPlayers();
  const sportName = matchData.sport?.name || '';
  const isSetBasedSport = ['Tennis', 'Volleyball', 'Badminton', 'Table Tennis'].includes(sportName);

  return (
    <div className="w-full max-w-2xl p-4 sm:p-5 rounded-2xl border border-gray-200 flex flex-col items-center gap-3 font-sans overflow-hidden">
      <p className="text-gray-600 text-sm text-center break-words w-full">
        {matchData.isTeamMatch ? 'Team Match' : '1 on 1'} at {matchData.location}
      </p>
      <div className="w-full space-y-2">
        {players.map((player, index) => (
          <div key={index} className="player">
            <div className="playerMainInfo">
              <div className="flex items-center gap-2 min-w-[100px] max-w-[150px] overflow-hidden">
                <img 
                  src={player.avatar} 
                  alt={`${player.name} avatar`} 
                  className="w-4 h-3 rounded flex-shrink-0"
                />
                <span className={`text-base truncate ${player.isWinner ? 'text-amber-700 font-medium' : 'text-gray-700'}`}>
                  {player.name} {player.isWinner && "👑"}
                </span>
              </div>
              <div className={`flex-shrink-0 ${player.isWinner ? 'text-amber-700' : 'text-gray-700'}`}>
                {isSetBasedSport ? 
                  renderScore(player.scores, index, sportName, false) :
                  renderScore(player.scores, index, sportName)}
              </div>
            </div>
            {isSetBasedSport && (
              <div className={player.isWinner ? 'text-amber-700' : 'text-gray-700'}>
                {renderScore(player.scores, index, sportName, true)}
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="text-amber-700 text-sm text-center break-words w-full">
        {sportName}, {new Date(matchData.date).toLocaleDateString()}, {new Date(matchData.date).toLocaleTimeString()}
      </p>
    </div>
  );
};

export default MatchCard;